module.exports = {"130432100":"广平镇","130432101":"平固店镇","130432102":"胜营镇","130432103":"南阳堡镇","130432201":"十里铺乡","130432202":"南韩村乡","130432204":"东张孟乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130432.json
// module id = 113
// module chunks = 0